//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from '@/components/NavBar.vue';
import CommonFooter from '@/components/CommonFooter.vue';
import TitleBox from '@/components/TitleBox.vue';
import ScrollTop from '@/components/ScrollTop.vue';
export default {
    components: { NavBar, CommonFooter, TitleBox, ScrollTop },
    beforeRouteEnter(to, from, next) {
        const obj = {
            travelGuide: 0,
            boutiqueIntroduction: 1,
            scenicSpots: 2,
            reminder: 3,
            contact: 4
        };
        const params = to.params;
        if (params.anchor && !params.id) {
            next(vm => {
                vm.currentItem = obj[params.anchor];
            });
            return;
        }
        if (params.anchor && params.id) {
            if (params.anchor === 'contact') {
                next(vm => {
                    vm.menuId = params.id;
                    vm.getMenuDetail(params.id);
                });
            }
            return;
        }
        next(vm => {
            vm.currentItem = 0;
        });
    },
    beforeRouteUpdate(to, from) {
        const obj = {
            travelGuide: 0,
            boutiqueIntroduction: 1,
            scenicSpots: 2,
            reminder: 3,
            contact: 4
        };
        this.currentItem = obj[to.query.anchor];
    },
    data() {
        return {
            typeList: [],
            menuList: [],
            currentItem: 0,
            guideDetail: '',
            strategyList: [],
            strategyDetail: '',
            nearByList: [],
            nearByDetail: '',
            tips: '',
            show: {
                vr: false,
                strategyDetail: false
            },
            serviceContent: '',
            banner: '',
            menuId: '',
            activeSlide: ''
        };
    },
    watch: {
        currentItem() {
            this.scrollTop();
            this.show.strategyDetail = false;
            if (this.currentItem === 1) {
                this.getStrategyList();
            }
            if (this.currentItem === 2) {
                this.getNearByList().then(res => {
                    this.initNearBy();
                });
            }
        },
        i18n() {
            this.scrollTop();
            this.show.strategyDetail = false;
            if (this.currentItem === 1) {
                this.getStrategyList();
            }
            if (this.currentItem === 2) {
                this.getNearByList().then(res => {
                    this.initNearBy();
                });
            }
        }
    },
    mounted() {
        this.getTypes();
        this.getTypes(0);
        this.getTips();
        this.getGuide();
        this.initMap();
    },
    methods: {
        initNearBy() {
            new window.Swiper('.swiper', {
                // 循环模式选项
                loop: false,
                /* autoplay: {
                    disableOnInteraction: false
                }, */
                effect: 'coverflow',
                slidesPerView: 'auto',
                centeredSlides: false,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 0,
                    modifier: 0,
                    slideShadows: false
                },
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            });
        },
        initMap() {
            var marker = new window.AMap.Marker({
                position: new window.AMap.LngLat(109.27182, 28.49819), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: '洪安',
                label: '洪安'
            });
            var map = new window.AMap.Map('map', {
                resizeEnable: true, // 是否监控地图容器尺寸变化
                zoom: 11, // 初始化地图层级
                center: [109.27182, 28.49819] // 初始化地图中心点
            });
            map.add(marker);
        },
        getTypes(showNav = 1) {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 3,
                    showNav
                }
            }).then(res => {
                if (res.code === 0) {
                    if (showNav) {
                        this.typeList = res.data;
                    } else {
                        this.menuList = res.data;
                    }
                }
            });
        },
        getGuide() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '50'
                }
            }).then(res => {
                if (res.code === 0) {
                    this.guideDetail = res.data;
                }
            });
        },
        getStrategyList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '51',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then(res => {
                if (res.code === 0) {
                    this.strategyList = res.data.data;
                }
            });
        },
        getStrategyDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 0) {
                    this.strategyDetail = res.data;
                    this.show.strategyDetail = true;
                }
            });
        },
        getNearByList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '52',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then(res => {
                if (res.code === 0) {
                    this.nearByList = res.data.data;
                    if (this.nearByList.length) {
                        this.getNearByDetail(this.nearByList[0].id);
                    } else {
                        this.nearByDetail = '';
                    }
                }
            });
        },
        getNearByDetail(id) {
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 0) {
                    this.activeSlide = id;
                    this.nearByDetail = res.data;
                }
            });
        },
        getTips() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '53'
                }
            }).then(res => {
                if (res.code === 0) {
                    this.tips = res.data;
                }
            });
        },
        traffic() {
            window.open(
                'https://www.amap.com/search?query=%E6%B4%AA%E5%AE%89%E8%BE%B9%E5%9F%8E&city=510000&geoobj=103.097668%7C30.536717%7C107.325236%7C32.456577&zoom=8.9',
                'blank'
            );
        },
        menuClick(data) {
            if (+data.showType === 3) {
                window.open(data.outUrl, 'blank');
            }
            if (+data.showType === 2) {
                this.scrollTop();
                this.menuId = data.id;
                this.getMenuDetail(data.id);
            }
        },
        getMenuDetail(id) {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 0) {
                    this.serviceContent = res.data;
                    this.currentItem = 4;
                }
            });
        }
    }
};
